import { render, staticRenderFns } from "./TroubleshootIcon.vue?vue&type=template&id=6b9c20a9&"
import script from "./TroubleshootIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TroubleshootIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports